// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Tooltip-module__tooltip--WEe_r{padding:5px 10px;background-color:#000;font-size:13px;border-radius:3px;display:flex;align-items:center;justify-content:center;color:#fff;z-index:10;max-width:330px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `Tooltip-module__tooltip--WEe_r`
};
export default ___CSS_LOADER_EXPORT___;
